import cx from 'classnames';
import React from 'react';
import { getOnEnter } from '../../_utils';
import { Icon, IconColor, IconID, IconSize } from '../../icon';
import { Typography } from '../../typography';
import styles from '../accordion.module.scss';
import { renderAccordionActionButtons, } from '../accordion-util';
import { AccordionVariant } from '../types';
export const AccordionHeader = ({ header, onClick, headerTooltip = '', actionButtons = [], toggleClass = '', variant = AccordionVariant.BASIC, actionButtonsAlwaysVisible = false, className, headerTitleRef, disabled = false, }) => {
    const onHeaderClick = (event) => {
        event.stopPropagation();
        onClick();
    };
    const renderAccordionToggleBtn = () => {
        const size = variant === AccordionVariant.BASIC
            ? IconSize.SMALL
            : IconSize.LARGE;
        return (React.createElement("span", { className: styles.accordionToggleBtn },
            React.createElement(Icon, { id: IconID.CHEVRON_RIGHT, color: IconColor.TEXT_COLOR, className: cx(styles.accordionActionIcon, styles[`accordionToggleIcon-${toggleClass}`]), size: size })));
    };
    const headerComponent = () => {
        let tooltipConfig;
        if (headerTooltip) {
            tooltipConfig = {
                dataTooltipContent: headerTooltip,
                dataTooltipAlign: 'left',
            };
        }
        const typographyVariant = variant === AccordionVariant.MINIMAL
            ? 'content-label'
            : 'content-label-subhead';
        return typeof header === 'string' ? (React.createElement("div", { ref: headerTitleRef },
            React.createElement(Typography, { variant: typographyVariant, ellipsis: { rows: 1 }, tooltipConfig: tooltipConfig, noMargin: true }, header))) : (header);
    };
    const opt = `${toggleClass}`;
    return (React.createElement("div", { className: cx(className, styles.accordionItemHeaderWrapper, styles[`accordion-${toggleClass}`]), onClick: onHeaderClick, role: "button", tabIndex: disabled ? -1 : 0, onKeyDown: getOnEnter(onHeaderClick), "aria-expanded": opt === 'expanded' },
        renderAccordionToggleBtn(),
        React.createElement("div", { className: styles.accordionitemHeaderInfo },
            React.createElement("span", { className: styles.accordionItemHeaderTitle }, headerComponent())),
        renderAccordionActionButtons(actionButtons, actionButtonsAlwaysVisible)));
};
//# sourceMappingURL=accordion-header.js.map